import { render, staticRenderFns } from "./JianHeLabelDialog.vue?vue&type=template&id=af6f0214&scoped=true"
import script from "./JianHeLabelDialog.vue?vue&type=script&lang=js"
export * from "./JianHeLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./JianHeLabelDialog.vue?vue&type=style&index=0&id=af6f0214&prod&scoped=true&lang=css"
import style1 from "./JianHeLabelDialog.vue?vue&type=style&index=1&id=af6f0214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f0214",
  null
  
)

export default component.exports